// modules
import { createAction } from 'redux-actions'

export const setActiveCompany = createAction('SET_ACTIVE_COMPANY')
export const toggleAddEditModal = createAction('TOGGLE_ADD_EDIT_MODAL')

export const setEditableCompany = createAction('SET_EDITABLE_COMPANY')
export const setCompanyUsers = createAction('SET_COMPANY_USERS')

export const setCompanyDivision = createAction('SET_COMPANY_DIVISION')
export const setCompanyDivisionByCompany = createAction(
  'SET_COMPANY_DIVISION_BY_COMPANY'
)

export const setEditableUser = createAction('SET_EDITABLE_USER')
export const setCompanyLanguages = createAction('SET_COMPANY_LANGUAGES')

export const setCompanyGoalCategories = createAction(
  'SET_COMPANY_GOAL_CATEGORIES'
)
export const setCompanyGoals = createAction('SET_COMPANY_GOALS')
export const setRpmCompanyGoals = createAction('SET_RPM_COMPANY_GOALS')

export const setUserRolePermissions = createAction('SER_USER_ROLE_PERMISSIONS')

export const clearCompanyAdministrating = createAction(
  'CLEAR_COMPANY_ADMINISTRATING'
)

export const setCompanyModalLoading = createAction('SET_COMPANY_MODAL_LOADING')

export const setUserEditRoles = createAction('SET_USER_EDIT_ROLES')

export const setCaseManagersByDivision = createAction(
  'SET_CASE_MANAGERS_BY_DIVISION'
)
export const setCompanyCaseManegers = createAction('SET_COMPANY_CASE_MANAGERS')

export const setCompanyGenders = createAction('SET_COMPANY_GENDERS')

export const setCompanyUserModalClinicians = createAction(
  'SET_COMPANY_USER_MODAL_CLINICIANS'
)

export const setAdminBillingPrograms = createAction(
  'SET_ADMIN_BILLING_PROGRAMS'
)

export const resetCompany = createAction('RESET_COMPANY')
